
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter,Redirect } from 'react-router-dom';
import {logout} from '../actions/AppActions';
import { connect } from 'react-redux';

class ProfileMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect:false,
            path:'/'
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    logout(){
        localStorage.removeItem('token');
        // this.setState({redirect:true,path:'/'});
        this.props.logout();
    }


    render() {

        return (
            <React.Fragment>
                {this.state.redirect === true && <Redirect to={this.state.path} />}
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block correcao-profile-menu" >
                    <DropdownToggle className="btn header-item waves-effect correcao-profile-toggle" id="page-header-user-dropdown" tag="button">
                        <span className="correcao-profile-meta">
                            <strong>{this.props.user?.name || 'Usuário'}</strong>
                            <small>{this.props.user?.email || 'OnTest'}</small>
                        </span>
                        <span className="header-profile-user correcao-profile-placeholder" aria-label="Perfil do usuário">
                            <i className="mdi mdi-account"></i>
                        </span>
                    </DropdownToggle>
                    <DropdownMenu right className="correcao-profile-dropdown">
                        <DropdownItem tag="a" className="correcao-profile-logout" onClick={this.logout.bind(this)}><i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>Logout</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user || {}
    }
);

export default withRouter(connect(mapsStateToProps, { logout })(ProfileMenu));
